import { MatDateFormats } from '@angular/material/core';
import { MAT_LUXON_DATE_FORMATS } from '@angular/material-luxon-adapter';

/**
 * Luxon datepicker formats that accept how people actually type a US date.
 *
 * The stock parse format is only `D` (M/d/yyyy in en-US), so `07-31-2026` and `7/31/26` were rejected.
 * The adapter tries ISO (`2026-07-31`) before these, and uses the first format that parses.
 * Two-digit years follow Luxon's cutoff: 00–60 → 20xx, 61–99 → 19xx.
 */
export const EE_LUXON_DATE_FORMATS: MatDateFormats = {
  ...MAT_LUXON_DATE_FORMATS,
  parse: {
    ...MAT_LUXON_DATE_FORMATS.parse,
    dateInput: ['D', 'M-d-yyyy', 'M/d/yy', 'M-d-yy']
  }
};
